export default "__VITE_ASSET__B2M2WZaE__"